module.exports = __webpack_public_path__ + "bbdf61fe43cf81a76a5245dde3825829.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-27.png
 ** module id = 1018
 ** module chunks = 0
 **/